module.exports = __webpack_public_path__ + "static/fonts/icomoon.9f5fd7b.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/vendor/wangEditorV2/fonts/icomoon.ttf?-qdfu1s
// module id = 3554
// module chunks = 6